import React, { useState } from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { LegalModal, LegalDocKey } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDocKey | null>(null);
  return <footer className="bg-ink pt-24 pb-12" data-id="element-52" data-mp="32pp601a99t4x">
      <div className="container mx-auto px-8 lg:px-12" data-id="element-53" data-mp="36oxyz3xh1mzf">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20" data-id="element-54" data-mp="36nd4tff2k623">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-55" data-mp="3ud7h9vvh7slt">
            <img src="https://cdn.magicpatterns.com/uploads/3iWP1S9hRbXKSgqthcd4fE/PNG_Logos_for_Nitido_Pro_1_1.png" alt="NÍTIDO PRO" className="w-28 mb-8" data-id="element-56" data-mp="38zaivynj750" />
            <p className="text-concrete/60 font-light text-sm leading-relaxed mb-8" data-id="element-57" data-mp="3qcdp2qb03rn4">
              Premium architectural-grade cleaning services. We don't just
              clean, we reset your spaces. Zero drama.
            </p>
            <div className="flex gap-6" data-id="element-58" data-mp="2ew6zmkkhri5y">
              <a href="#" className="text-concrete/60 hover:text-lime transition-colors" data-id="element-59" data-mp="3l90ntw47myz9">
                <Instagram size={20} strokeWidth={1.5} data-id="element-60" data-mp="3gc0ffejw1k4z" />
              </a>
              <a href="#" className="text-concrete/60 hover:text-lime transition-colors" data-id="element-61" data-mp="3v7zuj95f0kjm">
                <Facebook size={20} strokeWidth={1.5} data-id="element-62" data-mp="3q7bwi3irr3fw" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-63" data-mp="34739jgis1x5">
            <h4 className="text-paper text-xs font-medium mb-8 uppercase tracking-[0.2em]" data-id="element-64" data-mp="34patc8mu2kd">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-65" data-mp="hsa8urqnhblf">
              {['Services', 'Difference', 'Pricing', 'How it Works', 'Get a Quote'].map(link => <li key={link} data-id="element-66" data-mp="mrwm316haru8">
                  <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-concrete/60 hover:text-paper transition-colors font-light text-sm" data-id="element-67" data-mp="msy1tiyfw2ia">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-68" data-mp="18k0txuvng93i">
            <h4 className="text-paper text-xs font-medium mb-8 uppercase tracking-[0.2em]" data-id="element-69" data-mp="18kiydesgttmi">
              Service Areas
            </h4>
            <ul className="space-y-4" data-id="element-70" data-mp="1cl2rm79x4d3d">
              {['Orlando', 'Kissimmee', 'Broward', 'Davenport', 'Lake Nona', 'Winter Garden', 'Celebration'].map(area => <li key={area} className="text-concrete/60 font-light text-sm" data-id="element-71" data-mp="1rid2beeqley1">
                  {area}
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-72" data-mp="3tars0znivnp0">
            <h4 className="text-paper text-xs font-medium mb-8 uppercase tracking-[0.2em]" data-id="element-73" data-mp="3tccb9t4dzk7k">
              Contact Us
            </h4>
            <ul className="space-y-6" data-id="element-74" data-mp="25onds1nk19v5">
              <li data-id="element-75" data-mp="25nls738wx4z6">
                <a href="tel:9548181392" className="flex items-center gap-4 text-concrete/60 hover:text-paper transition-colors font-light text-sm" data-id="element-76" data-mp="25n3ue26lqip5">
                  <Phone size={16} className="text-lime" strokeWidth={1.5} data-id="element-77" data-mp="1wlm8u4afdot2" />
                  954-818-1392
                </a>
              </li>
              <li data-id="element-78" data-mp="2pbuqlv11u774">
                <a href="mailto:mynitidopro@gmail.com" className="flex items-center gap-4 text-concrete/60 hover:text-paper transition-colors font-light text-sm" data-id="element-79" data-mp="2pdflxmv6tu61">
                  <Mail size={16} className="text-lime" strokeWidth={1.5} data-id="element-80" data-mp="2fdor1k2ptd5f" />
                  mynitidopro@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-4 text-concrete/60 font-light text-sm" data-id="element-81" data-mp="13yib8kdnwcrb">
                <MapPin size={16} className="text-lime flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-82" data-mp="2rvzm7cez23t6" />
                <span className="leading-relaxed" data-id="element-83" data-mp="2wnr5r2zpn99t">
                  Orlando • Kissimmee • Broward • Florida
                  <br data-id="element-84" data-mp="2it86v1iz6nw9" />
                  &amp; surrounding areas
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-concrete/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-85" data-mp="3bkrv4zufis54">
          <p className="text-concrete/40 text-xs font-light tracking-wide" data-id="element-86" data-mp="3fksaqnt9l9dr">
            &copy; {new Date().getFullYear()} NÍTIDO PRO. All rights reserved.
          </p>
          <div className="flex gap-8 text-xs text-concrete/40 font-light tracking-wide" data-id="element-87" data-mp="36judqph8u24o">
            <button type="button" onClick={() => setOpenDoc('privacy')} className="hover:text-paper transition-colors" data-id="element-88" data-mp="1q5ugxndp2sln">
              Privacy Policy
            </button>
            <button type="button" onClick={() => setOpenDoc('terms')} className="hover:text-paper transition-colors" data-id="element-89" data-mp="1nkmr0g6j0v8l">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <LegalModal doc={openDoc} onClose={() => setOpenDoc(null)} data-id="element-90" data-mp="1rnsvpjdzqecy" />
    </footer>;
}